import s from './remove-homework.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useRemoveHomeworkModal } from '../../model/use-remove-homework-modal';
import { useRemoveHomework } from '../../api/useRemoveHomework';

export const RemoveHomeworkModal = () => {
	const {isOpen, close, modalParams} = useRemoveHomeworkModal()
	
	const appointmentId = modalParams?.appointmentId
	const homeworkId = modalParams?.homeworkId

	const {mutate: remove} = useRemoveHomework(appointmentId)
	
	const removeHomework = () => {
		remove({appointmentId, homeworkId})
		close()
	}

  return (
		<Modal {...{isOpen, close}}>
			<div className={s.card}>
					<div className={s.title}>Вы уверены?</div>
					<div className={s.text}>Вы точно хотете удалить домашнее задание?</div>
					<div className={s.btns}>
						<Button
							theme='secondary'
							className={s.btn}
							onClick={() => close()}
							label={'Нет'}
						/>
						<Button
							className={s.btn}
							onClick={removeHomework}
							label={'Да'}
						/>
					</div>
			</div>
		</Modal>
  );
};